import { Typography } from "@mui/material";
import Container from "@mui/material/Container";

import qRCode from "../../images/assets/qr.svg";
import lineupImage from "../../images/assets/lineupNew.png";

import appImage1 from "../../images/assets/1POST-ALL.jpg";
import appImage2 from "../../images/assets/2POST-SETTIMES.jpg";
import appImage3 from "../../images/assets/3POST MAP.jpg";
import appImage4 from "../../images/assets/4POST-COMMUNITY.jpg";

function StageTimes() {
  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            FREE Edinburgh Psych Fest 2026 App via WOOV.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Download the app for:
          </Typography>
          <Typography className="text">
            ⌚️ Full venue splits and stage times which you can personalise and
            plan your day.
          </Typography>
          <Typography className="text">🧭 3D map of the whole site.</Typography>
          <Typography className="text">
            🗣️ Chat to other festival goers in the community section.
          </Typography>
          <Typography className="text">
            Available from the link OR scan the QR code.
          </Typography>
          <a
            href="https://woov.to/edinburghpsychfest"
            target="_blank"
            rel="noreferrer"
          >
            https://woov.to/edinburghpsychfest
          </a>
        </div>

        <div>
          <img src={qRCode} className="qRCode-image" alt="qRCode" />
        </div>
        <div className="app-images">
          <img src={appImage1} className="app-image" alt="App One" />
          <img src={appImage2} className="app-image" alt="App Two" />
          <img src={appImage3} className="app-image" alt="App Three" />
          <img src={appImage4} className="app-image" alt="App Four" />
        </div>

                <div>
          <img src={lineupImage} className="lineup-image" alt="lineup" />
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Contact
          </Typography>
          <Typography className="text">info@edinburghpsychfest.com</Typography>
        </div>
      </div>
    </Container>
  );
}
export default StageTimes;
